import { SEAPORT, UNKNOWN } from '@/lib/constants';
import { LocationModel } from '@/lib/models/location/types';
import { MapMarker, MarkerSize, PortSequence } from '@/types';
import { getPreferredIdentifier } from '@/utils/helpers';

export const createLineMapMarkers = (locations: LocationModel[], portSequence: PortSequence[]): MapMarker[] => {
  if (!locations) return [];

  return locations.map((location, index) => {
    const id = getPreferredIdentifier(location.identifiers);
    const sequencePort = portSequence.find((p) => p.id === location.id);
    const isVisitedPort = !!sequencePort;
    const locationType = isVisitedPort ? SEAPORT : UNKNOWN;
    const color = isVisitedPort ? 'lightBlue.500' : 'grey.350';
    const size = isVisitedPort ? 'xl' : 'sm';

    return {
      id: `M_${location.id}_${index}`,
      size: size as MarkerSize,
      location: location.location,
      nodeType: locationType,
      label: id?.value || '',
      active: false,
      color,
      icon: '',
      value: sequencePort?.label.toString() || '',
      zIndex: isVisitedPort ? locations.length + index : index,
    };
  });
};
